<template>
  <div class="mask" @click.self="cancel_payment">
    <div v-if="finalfee>0" class="cashier">
      <span class="bold" style="">实付金额：<slot name="final"></slot></span>
      <p class="small">
        <span class="grey">订单号：<slot name="orderid"></slot></span>
      </p>
      <div class="frame">
        <slot name="weixin"></slot>
      </div>
      <p class="small grey center" style="margin-bottom: 20px;">请使用微信扫描二维码进行支付</p>
      <button class="white" @click="success_payment">支付成功后，点击此处跳转回课程页面</button>
    </div>
    <div v-else class="cashier">
      <h5 class="center bold hover" @click="success_payment" style="cursor: pointer;">您已支付成功！点击此处跳转回课程页面</h5>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "cashier",
  props: ["finalfee", "courseId"],
  methods: {
    cancel_payment: function () {
      this.$parent.cashier.show = false
      this.$parent.cashier.weixin = 'http://image.app.winlesson.com/subjejctInfoFolder/root/wl_19852_83808_49630.png';
      //     this.$parent.createOrder()
    },
    success_payment: function () {
      var course_id = this.$parent.order_content.course_id;
      this.$router.push({name: 'Video', params: {course_id: course_id}})
    }
  }
}

</script>
<style scoped>
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}

.cashier {
  background: #fff;
  position: absolute;
  margin: auto;
  top: 20%;
  left: 0;
  right: 0;
  width: 410px;
  padding: 40px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cashier h5 {
  font-family: PingFangSC-Medium;
  font-size: 14px;
}

.cashier .small {
  font-size: 12px;
}

.cashier .bold {
  font-family: PingFangSC-Medium;
  font-weight: bold;
}

.cashier .grey {
  color: #666;
}

.cashier span.money {
  font-family: PingFangSC-Medium;
  color: #e37d28;
}

.cashier .frame {
  width: 180px;
  height: 180px;
  margin: 30px auto;
}

.cashier .center {
  text-align: center;
}

.cashier button {
  display: block;
  margin: auto;
  padding: 5px 15px;
}

.cashier .hover:hover {
  text-decoration: underline;
}

button.white:focus,
button.white:hover,
button.white:active {
  background: #e5e5e5;
}

.cashier button {
  display: block;
  margin: auto;
  padding: 5px 15px;
  font-size: 14px;
  border-radius: 4px;
}

button.white {
  background: #fff;
  color: #333;
  border: 1px solid #e5e5e5;
}

.frame img:not(.icon) {

  width: 182px;
  position: absolute;
  top: 41%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Cashier.vue